import React, { useEffect, useState } from 'react'
import "./Post.css"
import Avatar from "@material-ui/core/Avatar"
import IconButton from "@material-ui/core/IconButton"
import FavoriteIcon from "@material-ui/icons/Favorite"
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder"
import { db, auth } from './firebase';
import firebase from 'firebase';
import MenuPopupState from "./components/MenuPopupState";
import Textarea from 'react-expanding-textarea';
import Linkify from 'react-linkify';
import {Modal} from '@material-ui/core';
import {Button, Input} from '@material-ui/core';
import {makeStyles } from '@material-ui/core/styles';


function getModalStyle() {
    const top = 50; 
    const left = 50;
  
    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }
  
  const useStyles = makeStyles((theme) => ({
    paper: {
      position: 'absolute',
      width: 440,
      maxWidth: 'calc(100% - 32px)',
      backgroundColor: theme.palette.background.paper,
      borderRadius: 18,
      border: '1px solid var(--green-line)',
      boxShadow: '0 20px 60px rgba(0, 48, 0, 0.18)',
      outline: 'none',
      padding: theme.spacing(3.5, 4),
    },
  }));

function Post({lang, postId, username, user, caption, likes, imageUrl, imagename, viewwhichuser}) {



    const classes = useStyles();
    const [modalStyle] = useState(getModalStyle);
    const [comments, setComments] = useState([]);
    const [comment, setComment] = useState('');
    const [commentToEdit, setCommentToEdit] = useState(null);
    const [editedComment, setEditedComment] = useState('');
    const [isEditingPost, setIsEditingPost] = useState(false);
    const [editedCaption, setEditedCaption] = useState('');
    const [isUpdatingLike, setIsUpdatingLike] = useState(false);

    const postLikes = Array.isArray(likes) ? likes : [];
    const isLiked = Boolean(user && postLikes.includes(user.uid));


    // Added this to make Linkify links open up in a new tab by default, and add the other AODA necessary parameters as well
    const componentDecorator = (href, text, key) => (
        <a href={href} key={key} target="_blank" rel="noopener noreferrer">
            {text}
        </a>
    );

    // What follows is for comments under a post, when a change is made, it refreshes
    useEffect(() => {
        let unsubscribe;
        if (postId) {
            unsubscribe = db
                .collection("posts")
                .doc(postId)
                .collection("comments")
                .orderBy('timestamp', 'asc')
                .onSnapshot((snapshot) => {
                    setComments(snapshot.docs.map((doc) => ({
                        id: doc.id,
                        ...doc.data()
                    })));
                })
        }

        return () => {
            unsubscribe();
        };
    }, [postId]);

    const postComment = (event) => {
        event.preventDefault();

        if (!comment.trim()) {
            return;
        }

        db.collection("posts").doc(postId).collection("comments").add({
            text: comment.trim(),
            username: user.displayName,
            timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
        setComment('');
            
    }

    function toggleLike() {
        if (!user || isUpdatingLike) {
            return;
        }

        setIsUpdatingLike(true);
        db.collection("posts")
            .doc(postId)
            .update({
                likes: isLiked
                    ? firebase.firestore.FieldValue.arrayRemove(user.uid)
                    : firebase.firestore.FieldValue.arrayUnion(user.uid)
            })
            .catch((error) => {
                console.error("Error updating post like: ", error);
            })
            .finally(() => {
                setIsUpdatingLike(false);
            });
    }

    function deletePost(postId) {
        // event.preventDefault();
        
        db.collection("posts").doc(postId).delete().then(function() {
            console.log("Document successfully deleted!");
        }).catch(function(error) {
            console.log("Error removing document: ", error);            
        });
        // Get a reference to the storage service, which is used to create references in your storage bucket
        var storage = firebase.storage();

        // Create a storage reference from our storage service
        var storageRef = storage.ref();

        // Create a reference to the file to delete
        var desertRef = storageRef.child('images/'+imagename);

        // Delete the file
        desertRef.delete().then(function() {
        // File deleted successfully
    
        }).catch(function(error) {
        // Uh-oh, an error occurred!

        });

    }

    function openCommentEditor(commentToEdit) {
        setCommentToEdit(commentToEdit);
        setEditedComment(commentToEdit.text);
    }

    function openPostEditor() {
        setEditedCaption(caption || '');
        setIsEditingPost(true);
    }

    function editPost(event) {
        event.preventDefault();

        db.collection("posts")
            .doc(postId)
            .update({ caption: editedCaption.trim() })
            .then(() => {
                setIsEditingPost(false);
                setEditedCaption('');
            })
            .catch((error) => {
                console.error("Error updating post: ", error);
            });
    }

    function editComment(event) {
        event.preventDefault();
        if (!commentToEdit || !editedComment.trim()) {
            return;
        }

        db.collection("posts")
            .doc(postId)
            .collection("comments")
            .doc(commentToEdit.id)
            .update({ text: editedComment.trim() })
            .then(() => {
                setCommentToEdit(null);
                setEditedComment('');
            })
            .catch((error) => {
                console.error("Error updating comment: ", error);
            });
    }

    function deleteComment(commentId) {
        db.collection("posts")
            .doc(postId)
            .collection("comments")
            .doc(commentId)
            .delete()
            .catch((error) => {
                console.error("Error deleting comment: ", error);
            });
    }

    function backtotop(){
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    // Function to view others' posts
    function viewtheirstuff(userselected) { 
        viewwhichuser(userselected);
        backtotop();
    }

     
    return (
        <div className="post">
            <div className="post__header">
                <Avatar 
                    className="post__avatar"
                    alt={username}
                    src="/static/images/avatar/1.jpg"
                    onClick={viewtheirstuff.bind(this, username) }
                />
                <div className="post__username" onClick={viewtheirstuff.bind(this, username)}>
                    <h3>{username} </h3>
                </div>
                {
                    user && (
                        username === user.displayName ||
                        user.email === "admin@gmail.com"
                    )
                    &&
                    <div className="delete__Post">
                    {/* This is where the 3 dots menu appear to delete POSTS */}
                        <MenuPopupState 
                            lang={lang}
                            datatopass={postId}
                            functiontopass={deletePost}
                            labeltopass={lang ? "Effacer cette publication":"Delete this post"}
                            editfunction={openPostEditor}
                            editlabel={lang ? "Modifier cette publication" : "Edit this post"}
                        />
                    </div>

                }
                
            </div>

            <div className="post__imgcontainer">

                { 
                // Check if the image is a video instead of an image, and if so, use the VIDEO tag instead
                (imageUrl.includes(".mp4")) || (imageUrl.includes(".MP4")) || (imageUrl.includes(".mov")) || (imageUrl.includes(".MOV")) 
                ? 
                    (
                    <video width="100%" max-width="500" controls="true" autoplay="true" loop="true" muted="true" playsinline="true">
                        <source src={imageUrl} type='video/mp4'></source>
                        Your browser does not support the video tag.
                    </video>
                    )
                    : 
                    (
                    // If it is NOT a video, load it as an image:
                    <img className="post__image" src={imageUrl} alt="" />
                    )
                }

            </div>            
            
            <div className="post__likes">
                <IconButton
                    className={`post__likeButton ${isLiked ? 'post__likeButton--liked' : ''}`}
                    aria-label={
                        user
                            ? (isLiked
                                ? (lang ? "Ne plus aimer cette publication" : "Unlike this post")
                                : (lang ? "Aimer cette publication" : "Like this post"))
                            : (lang ? "Connectez-vous pour aimer cette publication" : "Sign in to like this post")
                    }
                    aria-pressed={isLiked}
                    disabled={!user || isUpdatingLike}
                    onClick={toggleLike}
                    size="small"
                >
                    {isLiked ? (
                        <FavoriteIcon className="post__likeIcon post__likeIcon--liked" />
                    ) : (
                        <FavoriteBorderIcon className="post__likeIcon" />
                    )}
                </IconButton>
                <span>
                    {lang
                        ? `${postLikes.length} j’aime`
                        : `${postLikes.length} ${postLikes.length === 1 ? "like" : "likes"}`}
                </span>
            </div>


            <h4 className="post__text breakfix">
                {
                caption && // Only if the caption field is NOT empty, display it along with the user name
                    <Linkify componentDecorator={componentDecorator}>
                        <strong onClick={viewtheirstuff.bind(this, username)}>{username}: </strong>{caption}
                    </Linkify>
                }
            </h4>
            
            <Modal
                open={isEditingPost}
                onClose={() => setIsEditingPost(false)}
            >
                <div style={modalStyle} className={classes.paper}>
                    <form className="app__signup" onSubmit={editPost}>
                        <h3 className="modal__title">
                            {lang ? "Modifier la légende" : "Edit Caption"}
                        </h3>
                        <Input
                            autoFocus
                            multiline
                            rowsMin={2}
                            maxRows={8}
                            placeholder={lang ? "Légende" : "Caption"}
                            value={editedCaption}
                            onChange={(event) => setEditedCaption(event.target.value)}
                        />
                        <Button type="submit">
                            {lang ? "Enregistrer" : "Save"}
                        </Button>
                    </form>
                </div>
            </Modal>

            <div className="post__comments">
                {comments.map((comment) => {
                    const canManageComment = user && (
                        comment.username === auth.currentUser.displayName ||
                        auth.currentUser.email === "admin@gmail.com"
                    );

                    return (
                    <div className="comment_container" key={comment.id}>

                        <p className="post__comment breakfix">
                            <Linkify componentDecorator={componentDecorator}>
                                <strong onClick={viewtheirstuff.bind(this, comment.username)}>
                                    {comment.username}: 
                                </strong>  {comment.text}
                            </Linkify>
                        </p>
                        <div className="delete__CommentButton" >
                            {canManageComment &&
                                <div className="comment__morevert">
                                    <MenuPopupState 
                                        lang={lang}
                                        datatopass={comment.id}
                                        functiontopass={deleteComment}
                                        labeltopass={lang ? "Effacez ce commentaire":"Delete this comment"}
                                        editfunction={() => openCommentEditor(comment)}
                                        editlabel={lang ? "Modifier ce commentaire" : "Edit this comment"}
                                    />
                                </div>
                            } 
                        </div>


                    </div>

                    );
                })}
            </div>

            <Modal
                open={Boolean(commentToEdit)}
                onClose={() => setCommentToEdit(null)}
            >
                <div style={modalStyle} className={classes.paper}>
                    <form className="app__signup" onSubmit={editComment}>
                        <h3 className="modal__title">
                            {lang ? "Modifier le commentaire" : "Edit Comment"}
                        </h3>
                        <Input
                            autoFocus
                            multiline
                            rowsMin={1}
                            maxRows={8}
                            placeholder={lang ? "Commentaire" : "Comment"}
                            value={editedComment}
                            onChange={(event) => setEditedComment(event.target.value)}
                        />
                        <Button type="submit" disabled={!editedComment.trim()}>
                            {lang ? "Enregistrer" : "Save"}
                        </Button>
                    </form>
                </div>
            </Modal>


                {user && ( // Only display this comment form input if the user has logged in
                    <form className="post__commentBox">
                        <Textarea
                            className="post__input"
                            type="text"
                            placeholder={lang ? "Ajoutez un commentaire":"Add a comment"}
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                        />

                        <button
                            className="post__button"
                            disabled={!comment.trim()}
                            type="submit"
                            onClick={postComment}
                        >
                            {lang ? "Publier":"Post"}
                        </button>
                    </form>
                )}

        </div>
    )
}

export default Post
